import React,{ useState , useEffect} from 'react';
import CusProgressBar from '../components/CusProgressBar';
import config from '../appconfig/config.json';
import { Form, FormElement, FieldWrapper, Field } from '@progress/kendo-react-form';
import FormContainer from '../components/FormContainer';
import { useHistory } from "react-router-dom";
import service from '../services/ApiService.js';
import Loading from '../components/Loading';
import DeclarationChkbox from '../components/DeclarationChkbox';
import '../components/Popup.css';
import Popup from '../components/CusPopup';
import declardata from '../data/declarationdata.json';
import CusToast from '../components/CusToast';
import helper from '../factory/Helper';
import { TermsFormCheckboxNoErrMsgDisplay } from '../validation/Form-Components';
import { certBoardResoValidator } from '../validation/Validators';
import storage from '../factory/StorageFactory';

const configData = declardata;
 
const DeclarationDetails = (props) => {

    let timer;
    const seq0='0', seq1='1',seq2='2',seq3='3';
    const detailsType='8';
    const item = { bgcolor: "#389A6E", completed: 90 };
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(true);  //to show api call
    const [isSaving, setIsSaving] = useState(false);
    const [isError,setIsError] = useState(false);
    const [errMsg, setErrMsg] = useState('');

    const [nonSoleDeclare, setNonSoleDeclare] = useState();
  

    const initialResState = {
        // CompanyDetails Form
        CompDtls:{
            SoleorNonSole:""
        },
        ApplicantDtls:[],
        ApplicantsDtlsMyInfo:{}

    }
    const [response, setResponse] = useState(initialResState);

    const [buttonPopup, setButtonPopup] = useState(false);

    const [acctOpening22, setAcctOpening22] = useState({
        Declaration1:false,
        Declaration2:false,
        Declaration3:false,
        Declaration4:false,
        Declaration5:false,
        Declaration6:false
    })

    useEffect(() => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }

        if(helper.isInvalidState()) {
            window.location.href =  config.link.Cancle;
            return;
        }

        window.scrollTo(0,0);
        getData();

        return () => clearTimeout(timer);
     }, []);

     const handleSubmit = (eve) => {
        if(helper.isTokenExpired()) {
            history.push(config.route.SessionExpired);
            return;
        }
 
        //pure share holder
        if(storage.getIsLoginUserShareholder() !== null && storage.getIsLoginUserShareholder() === 'true') {
            saveDeclarationDetails(formatJsonParams(data));
            return;
        }
       // non pure share holder
        if(helper.isInvalidState()) {
            window.location.href =  config.link.Cancle;
            return;
        }
        
        let data = JSON.parse(JSON.stringify(eve.values));
       
        if(!checkValidation(data)){
            showErrMsg(config.error.TandC);
        }
        else{
            
           saveDeclarationDetails(formatJsonParams(data));
        }
    }

    const getData = () => {
        service.get().then( res => {
            if(res.data.isSucess){
                setResponse(res.data.model.fields.request);
                bindFormData(res.data.model.fields.request)
            }
            else{
                setIsLoading(false);
            }
        })
        .catch(err=>{
            
            setIsLoading(false);
        })
    }

    const isSoleProps = () => {
       
        if(response.CompDtls.SoleorNonSole === config.bizConst.Sole){
            return true;
        }
        else {
            return false;
        }
    }

    const showShareholder = () => {
        if(!isSoleProps()) {
            if(storage.getIsLoginUserShareholder() !== null && storage.getIsLoginUserShareholder() === 'true'){
                return true;
            }  
            return false;
        }
        else {
            return false;
        }
    }

    const bindFormData = (data) => {
    
        if(data && data.Declaration) {  // not first time
            if(data.CompDtls.SoleorNonSole === config.bizConst.Sole) { //Sole Props
                setDeclarations(data.Declaration);
            }
            else { // Non Sole Props
                //console.log('non sole props')
                setNonSoleDeclare(data.Declaration);
                if(getLoginUserOrder(data) === seq0) {
                    setDeclarations(data.Declaration.AuthPerSeq0);
                }
                else if(getLoginUserOrder(data) === seq1) {
                    setDeclarations(data.Declaration.AuthPerSeq1);
                }
                else if(getLoginUserOrder(data) === seq2) {
                    setDeclarations(data.Declaration.AuthPerSeq2);
                }
                else if(getLoginUserOrder(data) === seq3) {
                    setDeclarations(data.Declaration.AuthPerSeq3);
                }
            }
            setIsLoading(false);
        }
        else{
            setIsLoading(false);
        }
    }

    const setDeclarations = (data) => {
        setAcctOpening22({
            Declaration1:data.Declaration1 === 'true'? true:false,
            Declaration2:data.Declaration2 === 'true'? true:false,
            Declaration3:data.Declaration3 === 'true'? true:false,
            Declaration4:data.Declaration4 === 'true'? true:false,
            Declaration5:data.Declaration5 === 'true'? true:false,
            Declaration6:data.Declaration6 === 'true'? true:false
        });
    }

    const checkValidation = (data)=> {

        let valid = true;
        if(data.Declaration1 && data.Declaration2 && data.Declaration3 && data.Declaration4 && data.Declaration5 && data.Declaration6){
            valid= true;
        }
        else{
            valid = false;
        }
        return valid;
    }

    const formatJsonParams = (data) => {
        if(isSoleProps()) {
            return soleJsonParams(data);
        }
        else {
            if(storage.getIsLoginUserShareholder() !== null && storage.getIsLoginUserShareholder() === 'true') {
               return  pureShareholderJsonParams(data,getLoginUserOrder(response));
            }

            return nonSoleJsonParams(data,getLoginUserOrder(response));
        }
    }

    const soleJsonParams = (data) => {
        let params = {
            Declaration:{
                Declaration1:data.Declaration1,
                Declaration2:data.Declaration2,
                Declaration3:data.Declaration3,
                Declaration4:data.Declaration4,
                Declaration5:data.Declaration5,
                Declaration6:data.Declaration6
            }
        }
        return params;
    }

    const pureShareholderJsonParams = (data, seq)=> {
        let params = {
            Declaration:{
                AuthPerSeq0:{
                    Declaration1:false
                },
                AuthPerSeq1:{
                    Declaration1:false
                },
                AuthPerSeq2:{
                    Declaration1: seq === seq2? true:false
                },
                AuthPerSeq3:{
                    Declaration1: seq === seq3? true:false
                }
            }
        }
        return params;
    }

    const nonSoleJsonParams = (data, seq) => {
        
        let params = {
            Declaration:{
                AuthPerSeq0:{
                    Declaration1:seq === seq0? data.Declaration1:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration1 === "true"? true:false,
                    Declaration2:seq === seq0? data.Declaration2:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration2 === "true"? true:false,
                    Declaration3:seq === seq0? data.Declaration3:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration3 === "true"? true:false,
                    Declaration4:seq === seq0? data.Declaration4:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration4 === "true"? true:false,
                    Declaration5:seq === seq0? data.Declaration5:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration5 === "true"? true:false,
                    Declaration6:seq === seq0? data.Declaration6:nonSoleDeclare && nonSoleDeclare.AuthPerSeq0.Declaration6 === "true"? true:false
                },
                AuthPerSeq1:{
                    Declaration1:seq === seq1? data.Declaration1:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration1 === "true"? true:false,
                    Declaration2:seq === seq1? data.Declaration2:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration2 === "true"? true:false,
                    Declaration3:seq === seq1? data.Declaration3:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration3 === "true"? true:false,
                    Declaration4:seq === seq1? data.Declaration4:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration4 === "true"? true:false, 
                    Declaration5:seq === seq1? data.Declaration5:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration5 === "true"? true:false,
                    Declaration6:seq === seq1? data.Declaration6:nonSoleDeclare && nonSoleDeclare.AuthPerSeq1.Declaration6 === "true"? true:false
                },
                AuthPerSeq2:{
                    Declaration1:seq === seq2? data.Declaration1:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration1 === "true"? true:false,
                    Declaration2:seq === seq2? data.Declaration2:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration2 === "true"? true:false,
                    Declaration3:seq === seq2? data.Declaration3:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration3 === "true"? true:false,
                    Declaration4:seq === seq2? data.Declaration4:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration4 === "true"? true:false,
                    Declaration5:seq === seq2? data.Declaration5:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration5 === "true"? true:false,
                    Declaration6:seq === seq2? data.Declaration6:nonSoleDeclare && nonSoleDeclare.AuthPerSeq2.Declaration6 === "true"? true:false
                },
                AuthPerSeq3:{
                    Declaration1:seq === seq3? data.Declaration1:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration1 === "true"? true:false,
                    Declaration2:seq === seq3? data.Declaration2:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration2 === "true"? true:false,
                    Declaration3:seq === seq3? data.Declaration3:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration3 === "true"? true:false,
                    Declaration4:seq === seq3? data.Declaration4:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration4 === "true"? true:false,
                    Declaration5:seq === seq3? data.Declaration5:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration5 === "true"? true:false,
                    Declaration6:seq === seq3? data.Declaration6:nonSoleDeclare && nonSoleDeclare.AuthPerSeq3.Declaration6 === "true"? true:false
                }
            }
        }

        return params;
    }

    const getLoginUserOrder = (resObj) => {
        let authSeq = '', isAuthPerson = false;
        if(!Array.isArray(resObj.ApplicantDtls)){ //check obj or array
            if(resObj.ApplicantDtls.IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum){
                authSeq = resObj.ApplicantDtls.ApplicantSeq;
                isAuthPerson = true;
            }
            else {  //non login user
                authSeq = '0';
                isAuthPerson = false;
            }
        }
        else { //array
            for(let i in resObj.ApplicantDtls) {
                if(resObj.ApplicantDtls[i].IDNum ===  resObj.ApplicantsDtlsMyInfo.IDNum) {  // get login user's seq number 
                    authSeq = resObj.ApplicantDtls[i].ApplicantSeq;
                    isAuthPerson = true;
                }
            }
        }

        if(isAuthPerson){
            return authSeq;
        }
        else {
            return '0';
        }
    }
 

    const saveDeclarationDetails= (params) => {
        setIsSaving(true);
        service.post(detailsType,params).then(res=>{
            setIsSaving(false);
            let resData = res.data;
            if(resData.isSucess){
                history.push(config.route.Preview);
            }
            else {
                showErrMsg(config.error.SaveApiFailed);
            }          
        })
        .catch(err => {
            setIsSaving(false);
            showErrMsg(config.error.SaveApiFailed);
        });
    }
    
    const showErrMsg = (msg) => {
        setIsError(true);
        setErrMsg(msg);
        setErrMsgTimeout();
    }
    const setErrMsgTimeout= () => {
        timer = setTimeout(() => {
            setIsError(false);
        }, config.error.msgTimeout);
    }
    
    const handleBusizActiChkboxChange = (checkedValue,id) =>{
        
    }

    const showPopUpMsg = (e) => {
        e.preventDefault();
        setButtonPopup(true)
    }

    const backBtnClick = (e) => {
        e.preventDefault(); 
 
        if(history.location.state !== undefined) {

            if(history.location.state.from === config.route.NSUploadDetails) {
                history.push(config.route.NSUploadDetails);
            }
            else if(history.location.state.from === config.route.LLPUploadDetails){
                history.push(config.route.LLPUploadDetails);
            }
            else if(history.location.state.from === config.route.ACSUploadDetails){
                history.push(config.route.ACSUploadDetails);
            }
            else if(history.location.state.from === config.route.NonAuthPersonDetails) {
                history.push(config.route.NonAuthPersonDetails);
            }
        }
        else {
           // history.push(config.route.UploadDetails);
           history.push(config.route.AcctOpeningMY);
        }
    }

    const handleBack = (e) => {
        e.preventDefault();
        history.push(config.route.NSDelegationDetails2);
    }

    if(isLoading) {
        return(
            <Loading />
        )
    }

    return (
        <div id="" className="">           
        
        <h2 className='welcome mb-0'>Business Account Opening<br/>SME Banking</h2> 

        <br/>
        <div className="container-fluid">
            <Form onSubmitClick={handleSubmit} 
                initialValues={acctOpening22}
                key={JSON.stringify(acctOpening22)}
                render={(formRenderProps)=>(
                    <FormElement>
                        {!showShareholder() &&
                        <div style={{ textAlign: "center"}}>
                        <FormContainer>
                            <fieldset>
                                <div className="row around-xs elementVisible" style={{ marginTop: "1rem" }}>
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <legend>{configData.declarChkbox.header}</legend>
                                    </div>
                                </div>
                               
                                <div className="row around-xs inputPair elementVisible">
                                    {!isSoleProps()?
                                    <div style={{textAlign:'left'}}>
                                       {configData.declarChkbox.data.map((item, idx) => (
                                            <DeclarationChkbox key={idx} 
                                                id={item.id} lblname ={(<>{item.lblname1} 
                                                <a className="txtBlue" href={item.hrefLink} target="_blank">{item.lblname2}</a>{item.lblname3}
                                                <a className="txtBlue" href={item.hrefLink2} target="_blank">{item.lblname4}</a></>)} 
                                                onCheckedChange={handleBusizActiChkboxChange}
                                        />))}

                                         <DeclarationChkbox  
                                                id={'Declaration6'} lblname ={(<>{'I/We have read and agree to the '} 
                                                <a className="txtBlue" onClick={showPopUpMsg} href={''} target="_blank">{'advisory from the Singapore Police Force.'}</a>  </>)} 
                                                onCheckedChange={handleBusizActiChkboxChange} />

                                        {configData.declarChkbox.data2.map((item, idx) => (
                                            <DeclarationChkbox key={idx} 
                                                id={item.id} lblname ={(<>{item.lblname1} 
                                                <a className="txtBlue" href={item.hrefLink} target="_blank">{item.lblname2}</a> {item.lblname3}
                                                <a className="txtBlue" href={item.hrefLink2} target="_blank">{item.lblname4}</a></>)} 
                                                onCheckedChange={handleBusizActiChkboxChange}
                                        />))}
                                    </div>
                                    :
                                    <div style={{ textAlign: "left"}}>
                                    
                                    {configData.declarChkbox.dataSole.map((item, idx) => (
                                         <DeclarationChkbox key={idx} 
                                             id={item.id} lblname ={(<>{item.lblname1} 
                                             <a className="txtBlue" href={item.hrefLink} target="_blank">{item.lblname2}</a> {item.lblname3}
                                             <a className="txtBlue" href={item.hrefLink2} target="_blank">{item.lblname4}</a></>)} 
                                             onCheckedChange={handleBusizActiChkboxChange}
                                     />))}

                                      <DeclarationChkbox  
                                             id={'Declaration6'} lblname ={(<>{'I have read and agree to the '} 
                                             <a className="txtBlue" onClick={showPopUpMsg}  target="_blank">{'advisory from the Singapore Police Force.'}</a>  </>)} 
                                             onCheckedChange={handleBusizActiChkboxChange} />

                                     {configData.declarChkbox.data2Sole.map((item, idx) => (
                                         <DeclarationChkbox key={idx} 
                                             id={item.id} lblname ={(<>{item.lblname1} 
                                             <a className="txtBlue" href={item.hrefLink} target="_blank">{item.lblname2}</a> {item.lblname3}
                                             <a className="txtBlue" href={item.hrefLink2} target="_blank">{item.lblname4}</a></>)} 
                                             onCheckedChange={handleBusizActiChkboxChange}
                                     />))}
                               
                                 </div>}
                                </div>
                       
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box" style={{paddingLeft:'25px',paddingRight:'25px'}}>
                                            <div style={{fontSize: "13px",fontWeight:'500',textAlign:'left'}} id={'id1'}>{'Deposit Insurance Scheme '}</div>
                                            <div style={{fontSize: "13px",textAlign:'left',paddingTop:'5px'}} id={'id2'}>
                                                {configData.useNewSPF?configData.SHDeclareTxtNew:configData.SHDeclareTxt}
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </FieldWrapper>
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className="box" style={{paddingLeft:'25px',paddingRight:'25px'}}>
                                            <div style={{fontSize: "13px",fontWeight:'500',textAlign:'left'}} id={'id1'}>{'Fair Dealing Disclosure'}</div>
                                            <div style={{fontSize: "13px",textAlign:'left',paddingTop:'5px'}} id={'id2'}>
                                                {configData.fairDealing.lblname}
                                                <a className="txtBlue" href={configData.fairDealing.hrefLink} target="_blank">{"maybank.sg/fairdealing."}</a>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                </FieldWrapper>

                                <FieldWrapper>
                                    <div className="padDTC" style={{ textAlign: "left"}}> 
                                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />

                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                                <button className="btn btn-back" onClick={backBtnClick}>{config.btnName.Back}</button>
                                                <button type={'submit'} className="k-button btn btn-success btn-float-right" >{config.btnName.Next}</button>
                                            </div>
                                        </div> 
                                    </div>
                                </FieldWrapper>  
                       
                                <CusToast className="popUpBox" trigger={isError} setTrigger={setIsError} label={errMsg} timer={timer} />                                
                            </fieldset>
                        </FormContainer>
                        </div>
                        }
                        {showShareholder()&&
                        <FormContainer>
                            <fieldset>
                                <FieldWrapper>
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                    <div style={{textAlign:'center'}}>
                                        <legend>{configData.declarChkbox.header}</legend>
                                    </div>
                                    </div>
                                </div> 
                                </FieldWrapper>

                                <Field name={'Declaration1'} label={configData.SHTermAndCond} id={'Declaration1'}
                                    component={TermsFormCheckboxNoErrMsgDisplay} validator={certBoardResoValidator} />

                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className='dclare-chk-lbl'>
                                            <label id={'id1'}>
                                            {'Deposit Insurance Scheme'}<br/><br/>
                                            {configData.useNewSPF?configData.SHDeclareTxtNew:configData.SHDeclareTxt}</label> 
                                        </div>
                                    </div>
                                </div>
                            
                                <div className="row around-xs inputPair elementVisible">
                                    <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
                                        <div className='dclare-chk-lbl'>
                                            <label id={'id1'}>
                                            {'Fair Dealing Disclosure'}<br/><br/>
                                            {configData.fairDealing.lblname}
                                            <a className="txtBlue" href={configData.fairDealing.hrefLink} target="_blank">{"maybank.sg/fairdealing."}</a>
                                            </label> 
                                        </div>
                                    </div>
                                </div>
                              
                            </fieldset>
                        
                            <FieldWrapper>
                                    <div className="padDTC" style={{ textAlign: "left"}}> 
                                        <CusProgressBar bgcolor={item.bgcolor} completed={item.completed} />

                                        <div className="row around-xs inputPair elementVisible">
                                            <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12" style={{paddingBottom: "20px"}}>
                                                <button className="btn btn-back" onClick={handleBack}>{config.btnName.Back}</button>
                                                <button type={'submit'} className="k-button btn btn-success btn-float-right" disabled={!formRenderProps.valid}>{config.btnName.Next}</button>
                                            </div>
                                        </div> 
                                    </div>
                            </FieldWrapper>  
                           
                        </FormContainer>
                    }
                    </FormElement>
                )}>
            </Form>                                         
                               
            <br/><br/>                 

            <br/>
            <br/><br/> 
            {declardata.useNewSPF?
            <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                <div style={{ textAlign: "left" }}>
                    <div className="bgBlack fbaPSize">
                        <div className="row">
                            <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                <div className="dcPgmh">{'Advisory from the Singapore Police Force - Warning'}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                    <div className="row">
                        <div className="col-12">
                            <div className="dcPg fbaPSize">
                                {'Your payment accounts, like bank accounts are for your own use only. You may be held criminally liable if your payment account is used by others, e.g. for criminal activities.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                <ol>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not disclose your payment accounts/credentials to anyone else. </li>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not let anyone else access, operate or control your payment accounts.</li>
                                    <li><span style={{ height: '5px', width: '5px', backgroundColor: 'black', borderRadius: '50%', display: 'inline-block' }} />&nbsp;&nbsp;Do not receive or transfer money for anyone else using your payment accounts, unless you know him/her and know where he/she is.</li>
                                </ol>
                            </div>
                            <div className="fbaPSize">
                                {'You can be convicted for the relevant offences under the Corruption, Drug Trafficking and other Serious Crimes (Confiscation of Benefits) Act 1992 (CDSA) if your account is used for criminal activities. A person convicted of an offence under the CDSA may be liable for a fine up to $250,000, or imprisonment of up to five years, or both.'}
                            </div>
                            <div className="dcPg fbaPSize">
                                {'You should make the necessary application to your financial institution if you wish to authorise the operation, access and/or control of your account to a third party. A failure to do so would subject your account to additional risk mitigation measures, and in some cases, your financial institution may terminate or restrict your use of your account and other related accounts you may have with your financial institution.'}
                            </div>
                        </div>
                    </div>
                    </div>
                </div>
            </Popup>
            :
            <Popup className="popUpBox" trigger={buttonPopup} setTrigger={setButtonPopup}>
                <div style={{ textAlign: "left" }}>
                    <div className="bgBlack fbaPSize">
                        <div className="row">
                            <div className="col-xs-12 col-sm-11 col-md-11 col-lg-11">
                                <div className="dcPgmh">{'Advisory from the Singapore Police Force - Warning'}</div>
                            </div>
                        </div>
                    </div>
                    <div>
                        <div className="row">  
                            <div className="col-12">
                                <div className="dcPg fbaPSize">        
                                    {'Your bank account should be for your own use and you are responsible for all transactions made through your bank account.'}
                                </div>
                                <div className="dcPg fbaPSize">        
                                    {'You may be facilitating criminal activities such as money laundering and/or unlicensed money lending if you:'}
                                </div>
                                <div className="dcPg fbaPSize">  
                                    <ol>
                                        <li><span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> knowingly allow other people to operate, access and/or control of your bank account; and/or</li>
                                        <li><span style={{height:'5px',width:'5px',backgroundColor:'black',borderRadius:'50%', display:'inline-block'}} /> knowingly receive money from strangers, dubious sources, or other unverified sources</li>
                                    </ol> 
                                </div>
                                <div className="fbaPSize">        
                                    {'You can be prosecuted for the relevant offences if your bank account is used to receive or transfer money linked to criminal activities. These offences carry a punishment of a fine and/or imprisonment.'}
                                </div>
                                <div className="dcPg fbaPSize">        
                                    {'You should make the necessary application to your bank if you wish to authorise the operation, access and/or control of your bank account to a third party. A failure to do so would subject your bank account to additional risk mitigation measures and, in some cases, your bank may terminate or restrict your use of your bank account and other related accounts you may have with your bank.'}
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </Popup>
            }
        </div>
        {isSaving && <Loading />} 
      </div>

        );
    
}

export default DeclarationDetails;

